import { SyndicatedEpisode } from 'shared/data/episodes';
import { ParsedFeedItem } from './types';

export function mapEpisode(raw: ParsedFeedItem): SyndicatedEpisode {
  return {
    buzzsproutId: raw.buzzsproutId,
    episodeNumber: raw.episodeNumber,
    title: raw.title,
    description: raw.description,
    publishedDate: raw.publishedDate,
    audioUrl: raw.audioUrl,
    durationSeconds: raw.durationSeconds,
    artworkUrl: raw.artworkUrl,
  };
}
